import { useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BlockUser } from './action/BlockUser';
import { ReportUser } from './action/ReportUser';
import { useEffect } from 'react';
import config from '../../config';

export function ProfileActionButtons({ userId }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [openToast, setOpenToast] = useState(false);
  const toastRef = useRef(null);
  const menuButtonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuButtonRef.current && menuButtonRef.current.contains(e.target)) {
        return;
      }

      if (toastRef.current && !toastRef.current.contains(e.target)) {
        setOpenToast(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative">
      <div className="flex items-center justify-between gap-1 mt-[21px] mx-4">
        <img
          src="/icons/Button-back.svg"
          alt="Назад"
          onClick={() => {
            if (location.state?.from === config.ROUTES.NOTIFICATIONS) {
              navigate(config.ROUTES.NOTIFICATIONS, {
                state: {
                  from: location.state?.notificationOption || 1
                },
                replace: true
              });

              return;
            }

            if (location.state?.from?.startsWith('/chats/')) {
              navigate('/chats');
              return;
            }

            navigate(-1);
          }}
          className="w-[44px] h-[44px]"
        />
        <img
          ref={menuButtonRef}
          src="/icons/Button-dots.svg"
          alt="Меню"
          onClick={(e) => {
            e.stopPropagation();
            setOpenToast((prev) => !prev);
          }}
          className="w-[44px] h-[44px]"
        />
      </div>

      <div
        ref={toastRef}
        aria-hidden={!openToast}
        className={`absolute z-50 top-0 left-4 border border-[#233636] rounded-[12px] h-[180px] min-w-[291px] bg-[#1A2626] text-white transition-opacity duration-150 ${
          openToast ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div
          className="w-full border-b border-[#233636] h-[60px] flex items-center justify-between pl-[16px] pr-[16px]"
          onClick={() => {
            if (navigator.share) {
              navigator
                .share({
                  title: 'Поделиться профилем',
                  text: 'Поделитесь своим профилем',
                  url: window.location.href
                })
                .then(() => console.log('Успешно поделились'))
                .catch((error) => console.log('Ошибка при отправке:', error));
            } else {
              alert('Ваш браузер не поддерживает данную функцию');
            }
          }}
        >
          <span>Поделиться</span>
          <img src="/icons/share.svg" />
        </div>
        <ReportUser userId={userId} onTriggerClick={() => setOpenToast(false)} />
        <BlockUser userId={userId} onTriggerClick={() => setOpenToast(false)} />
      </div>
    </div>
  );
}
